export const LOGIN_SCREEN = 'LogInScreen';
export const FORGOT_CREDENTIAL = 'ForgotCredential';
export const CONFIRMATION = 'Confirmation';
export const RESET_PASSWORD = 'ResetPassword';
export const OTP = 'LogInOtp';
export const TIMEOUT = 'LogInTimeOut';

export const stepToComponentMap = {};
